<template>
  <v-card outlined class="app-card">
    <v-card-title class="app-card-title">Autos de Infração</v-card-title>
    <v-card-text class="app-card-content">
      <v-btn
        v-if="autosSelecteds && autosSelecteds.length > 0"
        depressed
        small
        color="#f79834"
        @click="imprimirAutos()"
        class="white--text btn-print"
      >
        <v-icon>print</v-icon>&nbsp; Imprimir Autos
      </v-btn>
      <br />
      <v-data-table
        :headers="table.headers"
        :items="table.content"
        :loading="table.isLoading"
        item-key="numeroAitp"
        item-value="numeroAitp"
        show-select
        v-model="autosSelecteds"
      >
        <template v-if="table.content.length" slot="items" slot-scope="props">
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td>
                <v-checkbox
                  v-model="props.autosSelecteds"
                  :disabled="
                    !props.autosSelecteds && autosSelecteds.length != 0
                  "
                  :indeterminate="
                    !props.autosSelecteds && autosSelecteds.length != 0
                  "
                ></v-checkbox>
              </td>
              <td>{{ item.numeroAitp }}</td>
              <td>{{ item.placa }}</td>
              <td>{{ item.dataLavratura }}</td>
            </tr>
          </tbody>
        </template>

        <template v-if="table.isLoading" v-slot:progress>
          <v-progress-linear indeterminate></v-progress-linear>
        </template>
      </v-data-table>
      <v-btn
        v-if="autosSelecteds && autosSelecteds.length > 0"
        depressed
        small
        color="#f79834"
        @click="imprimirAutos()"
        class="white--text btn-print"
      >
        <v-icon>print</v-icon>&nbsp; Imprimir Autos
      </v-btn>
      <div class="loading" v-if="isLoading">
        <v-progress-circular
          :size="25"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import AutoInfracaoService from "@/services/auto_infracao.service";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import GlobalStore from "@/store/modules/global";

export default {
  name: "ListaAutos",
  data() {
    return {
      currentTransportadora: null,
      table: {
        headers: [
          // {
          //   text: "",
          //   align: "start",
          //   sortable: false,
          //   value: "id"
          // },
          {
            text: "Número Aitp",
            align: "start",
            sortable: false,
            value: "numeroAitp"
          },
          {
            text: "Placa",
            align: "start",
            sortable: false,
            value: "placa"
          },
          {
            text: "Data Lavratura",
            align: "start",
            sortable: false,
            value: "dataLavratura"
          }
        ],
        content: [],
        isLoading: false
      },
      autosSelecteds: [],
      isLoading: false
    };
  },
  methods: {
    loadTransportadora() {
      this.currentTransportadora =
        TransportadoraAuthService.currentTransportadoraValue;
    },
    loadAutosInfracao() {
      this.table.isLoading = true;
      const { cnpj, token, numOrdem } = this.currentTransportadora;

      AutoInfracaoService.loadAutosInfracaoNotificar(cnpj, token,numOrdem).subscribe(
        response => {
          this.table.content = response;
          // this.table.content = response.map(auto => {
          //   auto.id = "";
          //   auto.action = "";
          //   return auto;
          // });
          this.table.isLoading = false;
        },
        error => {
          GlobalStore.setSnackBar({
            show: true,
            message: "Erro ao buscar autos de infração",
            type: "error"
          });
          this.table.isLoading = false;
        }
      );
    },
    imprimirAutos() {
      const autosInfracao = this.autosSelecteds.map(auto => auto.numeroAitp);
      if (autosInfracao && autosInfracao.length) {
        this.isLoading = true;
        AutoInfracaoService.imprimirAutosInfracao(autosInfracao).subscribe(
          res => {
            const file = new Blob([res], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.isLoading = false;
          },
          error => {
            GlobalStore.setSnackBar({
              show: true,
              message: "Erro ao tentar imprimir autos de infração",
              type: "error"
            });
            this.isLoading = false;
          }
        );
      }
    }
  },

  mounted() {
    this.loadTransportadora();
    this.loadAutosInfracao();
  }
};
</script>

<style lang="scss" scoped>
.btn-print {
  margin: 0px 10px 20px 0px;
}
</style>
